export default "__VITE_ASSET__BPxC44FX__"